<div *ngIf="editMetadataObj?.fields?.length > 0" style="padding:20px 5px 15px 5px;" class="primary-controls pull-right">
    <button class="btn btn-default btn-md" (click)="cancel()">{{LOCALIZATION.cancel}}</button>
    <button 
    	class="btn btn-primary btn-md" 
    	(click)="saveProductMetadata()" 
    	style="margin-right: 8px;"
        [disabled]="!kvForm.valid || inprogress">
        	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
         	{{LOCALIZATION.save}}
    </button>
</div>                
<form #kvForm="ngForm" name="kvForm">
	<div ngModelGroup="editFields">
        <edit-field-collection 
        	[fields]="editMetadataObj.fields" 
        	[values]="editMetadataObj.metadata" 
        	[parentForm]="kvForm" 
        	(triggerBrowseEdit)="onBrowseEdit($event.fieldName, $event.index)"
        	(triggerGeotag)="onGeotag($event.fieldName, $event.index)">
        </edit-field-collection>
    </div>
</form>
<div *ngIf="editMetadataObj?.fields?.length > 0" style="padding:20px 5px 15px 5px;" class="primary-controls pull-right">
    <button class="btn btn-default btn-md" (click)="cancel()">{{LOCALIZATION.cancel}}</button>
    <button 
    	class="btn btn-primary btn-md" 
    	(click)="saveProductMetadata()" 
    	style="margin-right: 8px;"
        [disabled]="!kvForm.valid || inprogress">
        	<i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
         	{{LOCALIZATION.save}}
    </button>
</div>
<div *ngIf="editMetadataObj?.fields?.length == 0">
    <em>{{LOCALIZATION.emptyForm}}</em>
</div>
